/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="82.25" height="67.11" viewBox="0 0 82.25 67.11" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path d="M62.56,44A14.12,14.12,0,1,0,76.68,58.12,14.12,14.12,0,0,0,62.56,44Zm0,2.5A11.62,11.62,0,1,1,50.94,58.12,11.62,11.62,0,0,1,62.56,46.5Z" transform="translate(-36.5 -44)" fill="#0e497b"/><path d="M68.48,80.53A1.25,1.25,0,0,1,68.61,83H49.94A10.94,10.94,0,0,0,39,93.68v2.1a1.25,1.25,0,0,1-2.49.13V94A13.45,13.45,0,0,1,49.63,80.53H68.48Z" transform="translate(-36.5 -44)" fill="#0e497b"/><path d="M96.47,66.54a22.29,22.29,0,1,0,22.28,22.29A22.29,22.29,0,0,0,96.47,66.54Zm0,2.5A19.79,19.79,0,1,1,76.68,88.83,19.79,19.79,0,0,1,96.47,69Z" transform="translate(-36.5 -44)" fill="#0e497b"/><path d="M96.42,77.66a1.24,1.24,0,0,1,1.24,1.12V98.62a1.25,1.25,0,0,1-2.49.12V78.91A1.25,1.25,0,0,1,96.42,77.66Z" transform="translate(-36.5 -44)" fill="#ffb81c"/><path d="M106.27,87.51a1.25,1.25,0,0,1,.13,2.5H86.57a1.25,1.25,0,0,1-.13-2.49h19.83Z" transform="translate(-36.5 -44)" fill="#ffb81c"/>
</svg>

    );
  }
}

Icon.displayName = 'PersonWithPlusCircleIcon';

export default Icon;
